var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (autofocus, buttonText, email, redirectTo, setPassword) {
buf.push("<div id=\"auth-page\" class=\"vam-outer\"><div class=\"vam-inner\"><header id=\"auth-header\"><div id=\"auth-header-logo\" class=\"icon-logotype\"></div></header><section id=\"auth-body\"><div class=\"auth-register\"><form class=\"auth-form\">");
if (setPassword)
{
buf.push("<p>Get a unique link sent to your email and finish creating your account.</p>");
}
buf.push("<input name=\"email\"" + (jade.attr("value", email, true, true)) + " type=\"email\" placeholder=\"Email\"" + (jade.attr("autofocus", autofocus, true, true)) + " required class=\"bordered-input is-block\">");
buttonText = setPassword ? 'Submit' : 'Send me reset instructions'
buf.push("<button id=\"auth-submit\" class=\"avant-garde-button-black is-block\">" + (jade.escape(null == (jade_interp = buttonText) ? "" : jade_interp)) + "</button>");
if (!setPassword)
{
buf.push("<footer class=\"auth-form-options\"><a href=\"/log_in\" data-mode=\"login\" class=\"auth-toggle\">I remember it!</a></footer>");
}
buf.push("</form></div></section>");
if (!setPassword)
{
buf.push("<footer id=\"auth-footer\"><p class=\"auth-mode-toggle\">Don&rsquo;t have an account?&nbsp;<a data-mode=\"signup\"" + (jade.attr("href", '/sign_up?redirect-to=' + redirectTo, true, true)) + " class=\"small-caps auth-toggle\">Sign up</a></p></footer>");
}
buf.push("</div></div>");}.call(this,"autofocus" in locals_for_with?locals_for_with.autofocus:typeof autofocus!=="undefined"?autofocus:undefined,"buttonText" in locals_for_with?locals_for_with.buttonText:typeof buttonText!=="undefined"?buttonText:undefined,"email" in locals_for_with?locals_for_with.email:typeof email!=="undefined"?email:undefined,"redirectTo" in locals_for_with?locals_for_with.redirectTo:typeof redirectTo!=="undefined"?redirectTo:undefined,"setPassword" in locals_for_with?locals_for_with.setPassword:typeof setPassword!=="undefined"?setPassword:undefined));;return buf.join("");
};
module.exports = template;